<template>
    <div>
<!--        <van-nav-bar-->
<!--                title="公司简介"-->
<!--                left-text=""-->
<!--                left-arrow-->
<!--                fixed-->
<!--                @click-left="back()"-->
<!--                v-if="show"-->
<!--        />-->

        <div class="searchwarp">

            <div class="van-cell-group van-hairline--top-bottom van-panel" style="border-bottom: 0">

                <div class="van-panel__content" style="line-height: 1.8">
                    <div>
                        <P style="font-weight: bold">
                            大宗商品仓储服务：
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            1、现货储存：瑞和仓储集团现有瑞和库区（非交割业务）、新兴库区（交割业务）等多个仓储库区，主要的仓储品种为有色金属、黑色金属、木材及小商品等，拥有多条铁路专用线，集成专用线卸货、理货验收、入库分堆到按指令出库放行等一站式服务。
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            瑞和仓储集团采用先进信息化管理系统，配备一流大型作业设备及信息终端，为客户提供安全、快捷、规范的仓储服务，年吞吐能力达到200万吨，在国内仓储业中名列前茅。
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            2、天津市新兴伟业集装箱装卸服务有限公司为上海期货交易所指定交割仓库，可为客户办理货物入库到制成标准仓单等业务，交割品种为锌品种。
                        </P>
                        <p><img src="../../assets/image/bizpic1.jpg" width="100%"/></p>
                    </div>
                    <div>
                        <P style="font-weight: bold">
                            商品融资服务：
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            瑞和仓储集团致力于解决企业物流增值难题，依托深耕大宗商品物流行业多年的经验，率先在国内开展商品融资管理业务，为客户提供担保存货管理及个性化的供应链物流服务，业务范围涵盖黑色金属、有色金属、矿产品等多个产品类型，先后与国内外主要商业银行、金融机构以及广大产业客户建立了良好合作关系、达成了稳固战略合作。
                        </P>
                        <p><img src="../../assets/image/bizpic2.jpg" width="100%"/></p>
                    </div>
                    <div>
                        <P style="font-weight: bold">
                            运输及货代服务：
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            1、道路运输服务：瑞和仓储集团拥有高素质的运输队伍，在行业中率先将“GPS全球卫星定位”、“短信平台”、“SAP信息管理系统”等先进技术综合运用于日常运营管理中，为客户提供安全、高效、低成本的服务。
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            2、海运货代服务：瑞和仓储集团拥有资深的行业经验，对国内各大口岸的通关环境尤为熟悉，与主要港口及多家船东建立了长期良好的合作关系，承接国内主要港口的集装箱及干散货清报关业务，为客户提供快捷高效的集装箱和干散货的海陆联运、海铁联运及散货租船服务。南储集团货运代理服务已全面覆盖国内主要城市的铁路、公路运输网络及国内外主要港口，致力于打造专业可靠的门到门全流程服务。
                        </P>
                        <p><img src="../../assets/image/bizpic3.jpg" width="100%"/></p>
                    </div>
                    <div>
                        <P style="font-weight: bold">
                            商务信息服务:
                        </P>
                        <P style="text-indent:2em;text-align:justify;">
                            瑞和仓储集团提供独立、客观、专业的第三方报价、每日市场评述以及产业链分析研究报告，为客户参与市场竞争提供决策参考依据。
                        </P>
                    </div>
                </div>
            </div>



        </div>

<!--        <van-row gutter="20" style="margin-top:10px">-->
<!--            <van-col span="8" offset="8">-->
<!--                <van-button block size="small" plain type="info" native-type="submit" class="button"-->
<!--                            @click="back()">-->
<!--                    关闭-->
<!--                </van-button>-->
<!--            </van-col>-->
<!--        </van-row>-->







    </div>
</template>

<script>
    import Vue from 'vue'
    import {
        Button,
        Calendar,
        Cell,
        Col,
        Divider,
        Field,
        Form,
        Grid,
        GridItem,
        Icon,
        Image as VanImage,
        ImagePreview,
        Lazyload,
        List,
        NavBar,
        Picker,
        Popup,
        PullRefresh,
        Radio,
        RadioGroup,
        Row,
        Search,
        Sticky,
        SwipeCell,
        Toast
    } from 'vant';
    import service from '../../server/index'

    Vue.use(Lazyload, {
        lazyComponent: true,
    });

    export default {
        name: "Fleet",
        components: {
            [NavBar.name]: NavBar,
            [Search.name]: Search,
            [List.name]: List,
            [Col.name]: Col,
            [Row.name]: Row,
            [Cell.name]: Cell,
            [SwipeCell.name]: SwipeCell,
            [Button.name]: Button,
            [Popup.name]: Popup,
            [Icon.name]: Icon,
            [Field.name]: Field,
            [PullRefresh.name]: PullRefresh,
            [Sticky.name]: Sticky,
            [RadioGroup.name]: RadioGroup,
            [Radio.name]: Radio,
            [Calendar.name]: Calendar,
            [Divider.name]: Divider,
            [VanImage.name]: VanImage,
            [ImagePreview.Component.name]: ImagePreview.Component,
            [Grid.name]: Grid,
            [GridItem.name]: GridItem,
            [Form.name]: Form,
            [Picker.name]: Picker
        },
        computed: {},
        data() {
            return {
                show: true,//nav bar
                list: [],
                loading: true,
                finished: false,
                searchValue: {},
                showPickerNotifySta: false,
                selProcessNotifyStatus: '',
                selProcessName: '',
                showPickerPro: false,
                selMachineName: '',
                showPickerMac: false,
                selMachineDetailName: '',
                showPickerMacD: false,
                selProcesstaskStatus: '',
                showPickerProSta: false,
                date: '',
                processData: [],
                processCol: [],
                machineData: [],
                machineCol: [],
                machineDetailData: [],
                machineDetailCol: [],
                addShowPop: false,
                dateFormat: 'YYYY-MM-DD',
                //刷新
                isLoading: false,
                page: 1,
                pageSize: 20,
                //日期选择calendarShow
                calendarShow: false,
                taskCount: 0,
                sumWeight: 0,
                notifyCount: 0,
                //详情pop
                detailPop: false,
                detailList: [],
                packageDetailPop:false,
                productDetailPop:false,
                packageList: [],
                packageNo:[]
            }
        },
        mounted() {
            this.onLoad();
            let parm = {};
            parm.ouid = localStorage.getItem("ouid")
            service.selProcessG(parm).then(res => {
                let data = res.data;
                this.processData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.processCol.push(data[i].processName)
                }
            })
            service.selMachineNameG(parm).then(res => {
                let data = res.data;
                this.machineData = res.data;
                for (let i = 0; i < data.length; i++) {
                    this.machineCol.push(data[i].machineName)
                }
            })
        },

        methods: {
            formatDate(date) {
                return `${date.getMonth() + 1}/${date.getDate()}`;
            },
            onConfirm(date) {
                this.show = false;
                this.date = this.formatDate(date);
            },
            back() {
                this.$router.replace("/Home/Search")
            },
            addPop() {
                this.show = true;
                this.addShowPop = true;
            },

            onSearch() {
                this.list = [];
                this.page = 1;
                this.show = true;
                this.addShowPop = false;
                this.onLoad();
            },
            onLoad() {
                // 异步更新数据
                // setTimeout 仅做示例，真实场景中一般为 ajax 请求
                setTimeout(() => {
                    for (let i = 0; i < 10; i++) {
                        this.list.push(this.list.length + 1);
                    }

                    // 加载状态结束
                    this.loading = false;

                    // 数据全部加载完成
                    if (this.list.length >= 40) {
                        this.finished = true;
                    }
                }, 1000);
            },
            getDetailList() {
                let createTimeStart = "";
                let createTimeEnd = "";
                let dateStr = this.searchValue
                if (dateStr != null && dateStr != "" && this.searchValue.startDate != "" && this.searchValue.endDate != "") {
                    createTimeStart = this.searchValue.startDate;
                    createTimeEnd = this.searchValue.endDate
                }

                let searchObj = this.searchValue
                searchObj.startDate = createTimeStart
                searchObj.endDate = createTimeEnd
                searchObj.page = this.page;
                searchObj.size = this.pageSize;
                searchObj.ouid = localStorage.getItem("ouid")
                searchObj.customerId = localStorage.getItem("customerId")
                service.selJgProcessnotify(JSON.parse(JSON.stringify(searchObj))).then(res => {
                    if (res.code == "200") {
                        if (res.data.length > 0) {
                            for (let i = 0; i < res.data.length; i++) {
                                this.list.push(res.data[i]);
                            }
                            this.page++
                        } else {
                            this.finished = true;
                        }
                        // 加载状态结束
                        this.loading = false;
                        this.isLoading = false;
                    } else {
                        this.loading = false;
                        this.finished = true;
                        this.isLoading = false;
                        Toast(res.message)
                    }
                })
            },




        }
    }
</script>

<style scoped>


    .searchwarp {
        margin-top: 0px;
        height: calc(100vh - 5px);
        overflow: auto;
    }

    /*/deep/ .van-cell__title {*/
    /*    text-align: left;*/
    /*    -webkit-box-flex: unset;*/
    /*    -webkit-flex: unset;*/
    /*    flex: unset;*/
    /*}*/
    .van-panel__content{
        padding: 10px 16px;
        text-align: left;
        font-size: 16px;
    }
    .searchwarp .van-hairline--top-bottom::after {
        border-width:0;
    }
</style>
